import { render } from "./addEvaLesson.vue?vue&type=template&id=1becf03a&scoped=true"
import script from "./addEvaLesson.vue?vue&type=script&lang=js"
export * from "./addEvaLesson.vue?vue&type=script&lang=js"

import "./addEvaLesson.vue?vue&type=style&index=0&id=1becf03a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1becf03a"]])

export default __exports__